export default {
  vip_label: 'VIP{level}',
  xp_value: '{xp} XP',
  xp_to_next: '{remaining}XP to {next}',
  total_balance: 'Total balance',
  todays_earnings: "Today's earnings",
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  transactions: 'Transactions',
  history: 'History',
  betting_orders: 'Betting orders',
  total_pnl: 'Total PnL',
  real_time_rebate: 'Rebate',
  view_more: 'View More',
  referral: 'Referral',
  sign_out_confirm_title: 'Signing Out',
  sign_out_confirm_body:
    'Are you sure you want to log out? Check our great promotions and bonuses before you leave!',

  // VIP page
  vip_current_perks: 'Current perks',
  vip_all_levels: 'All levels',
  vip_col_level: 'Level',
  vip_col_xp_needed: 'XP needed',
  vip_col_bonus: 'Bonus',
  vip_col_levelup_bonus: 'Level-up bonus',
  vip_col_required_xp: 'Required XP',
  vip_level_benefits: 'VIP level & Benefits',
  vip_target_audience: 'Target audience: All new and existing members',
  vip_xp_to_next: '{xp}XP to VIP{level}',
  vip_perk_checkin: 'Daily check-in bonus',
  vip_perk_slot_rebate: 'Slot rebate',
  vip_perk_live_rebate: 'Live casino rebate',
  vip_perk_sport_rebate: 'Sport rebate',
  vip_perk_withdrawal_limit: 'Withdrawal limit',
  vip_perk_dedicated_support: 'Dedicated support',

  // GameData page
  game_data: 'Game data',
  game_history: 'Game history',
  game_pnl: 'Game PnL',
  rebate_amount: 'Rebate amount',
  activity_amount: 'Activity amount',
  betting_amount: 'Betting amount',
  valid_betting_amount: 'Valid betting amount',
  betting_time: 'Betting time',
  order_id: 'Order ID',
  prize: 'Prize',
  all_data_displayed: 'All data displayed',
  select_type: 'Select type',
  select_state: 'Select state',
  all_type: 'All type',
  all_states: 'All status',
  total_rebate: 'Total Rebate',
  rebate_rate: 'Rebate rate',
  game_type: 'Game type',

  // RebateRate page
  game_provider: 'Game provider',
  rebate_level: 'Rebate level',
  total_betting_amount: 'Total betting amount',
  gameplay: 'Gameplay',
  gameplay_type: 'Gameplay type',
  rebate: 'Rebate',
  select_game: 'Select game',

  // DateRangeSheet
  select_time: 'Select time',
  within_24h: 'Within 24 hours',
  within_7d: 'Within 7 days',
  within_15d: 'Within 15 days',
  within_30d: 'Within 30 days',
  // Calendar date range picker (replaces preset DateRangeSheet)
  select_date_range: 'Select date range',
  start_date: 'Start date',
  end_date: 'End date',
  preset_today: 'Today',
  preset_yesterday: 'Yesterday',
  preset_this_week: 'This week',
  preset_this_month: 'This month',
  preset_last_month: 'Last month',

  // SettingsPage
  settings_notification_preferences: 'Notification preferences',
  settings_privacy: 'Privacy',
  settings_security: 'Security',
  settings_about: 'About 99H.COM',
  settings_help_support: 'Help & support',

  // === Artwork-led Mine ===
  title: 'Mine',
  total_assets: 'Total assets',
  member_for: 'Member for {n} days',
  no_signature: 'No signature set',
  qa_wallet: 'My wallet',
  qa_account: 'Account details',
  qa_bets: 'Bet history',
  qa_security: 'Security',
  menu_chase: 'Chase records',
  menu_affiliate: 'Affiliate plan',
  menu_influencer: 'Media partner',
  menu_help: 'Help centre',
  menu_settings: 'Settings',
  menu_device: 'Device info',
  feature_vip: 'VIP privileges',
  feature_invite: 'Invite friends',
  // Joint-venture recruitment page (see pages/Mine/JointVenture). Every
  // word on that page is inside a picture; these are the accessible names.
  joint_venture_title: 'Joint Venture Partners',
  joint_venture_info_alt: 'Partner programme details',
  joint_venture_cta: 'Become a joint venture partner',
  joint_venture_empty: 'Partner programme details are not available yet.',
};
